import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LocaleStrings from "Languages";
import {
  fetchReviewerList,
  deleteProposalReviewer,
  openReviewerPassowrdModal,
} from "ProposalAction";

class ReviewerItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { copied: false };
    this.deleteUser = this.deleteUser.bind(this);
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  deleteUser() {
    confirmAlert({
      title: LocaleStrings.reviewer_title_delete_reviewer,
      message: LocaleStrings.reviewer_text_permanently_delete_reviewer,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteProposalReviewer(
              this.props.session,
              this.props.reviewer,
              (response) => {
                if (response.success === 0) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.fetchReviewerList(this.props.session);
                  this.props.showSuccess(
                    LocaleStrings.proposal_reviewer_deleted
                  );
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  changePasswordModal = () => {
    let { reviewer } = this.props;
    this.props.openReviewerPassowrdModal(true, reviewer);
  };

  render() {
    let { reviewer } = this.props;
    // console.log('reviewer',reviewer);

    return (
      <tr>
        <td className="first-td">
          {reviewer.firstname + " " + reviewer.lastname}
        </td>
        <td className="middle-td">{reviewer.email}</td>

        <td className="last-td" style={{ width: 400 }}>
          <div className="action-button" style={{ marginLeft: 5 }}>
            <button
              className="btn btn-custom-table-white"
              onClick={this.deleteUser}
            >
              {LocaleStrings.proposal_reviewer_remove_text}
            </button>
          </div>
          <div className="action-button" style={{ marginLeft: 5 }}>
            <button
              className="btn btn-custom-table-white"
              onClick={this.changePasswordModal}
            >
              {LocaleStrings.proposal_reviewer_change_password}
            </button>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps, {
  fetchReviewerList,
  deleteProposalReviewer,
  showError,
  showSuccess,
  openReviewerPassowrdModal,
})(ReviewerItem);
